// HashtagCategoryItem.jsx
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { searchType } from '../resource/searchConstants.js';
import trackMixpanel, {
  EventTypes,
  ButtonId,
  getViewId,
} from '../resource/mixpanel.js';

import media from '../style/media.js';

export const HashtagCategoryItem = ({
  hashtag,
  index,
  type,
  category,
  i18n,
  setRecentSearchHashtag,
  t,
}) => {
  const i18nKey = `hashtag_${hashtag}`;
  return (
    <StyledHashtagCategoryItem
      to={`/hashtag/${hashtag}/${type}`}
      onClick={() => {
        setRecentSearchHashtag({ query: hashtag });
        trackMixpanel({
          type: EventTypes.USER_CLICKED,
          payload: {
            viewId: getViewId({ pathname: window.location.pathname }),
            buttonId: ButtonId.Home.ButtonTrendingHashtag,
            extraProps: {
              'discover.index': index + 1,
              'discover.category': category,
              'hashtag.content': hashtag,
            },
          },
        });
      }}
    >
      #{i18n.exists(i18nKey) ? t(i18nKey) : hashtag}
    </StyledHashtagCategoryItem>
  );
};

HashtagCategoryItem.propTypes = {
  hashtag: PropTypes.string,
  index: PropTypes.number,
  type: PropTypes.string,
  category: PropTypes.string,
  i18n: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  setRecentSearchHashtag: PropTypes.func,
};

HashtagCategoryItem.defaultProps = {
  hashtag: '',
  category: '',
  index: 0,
  type: searchType.FLIX,
  setRecentSearchHashtag: () => null,
};

const StyledHashtagCategoryItem = styled(Link)`
  margin-right: 8px;
  border-radius: 30px;
  padding: 0px 20px;
  display: flex;
  align-items: center;
  height: 36px;
  font-size: 18px;
  cursor: pointer;
  white-space: nowrap;
  background-color: rgba(255, 255, 255, 0.1);
  list-style: none;
  :last-child {
    margin-right: 0px;
  }
  ${media.tablet`
    margin-right: 4px;
    padding: 0px 12px;
    height: 28px;
    font-size: 14px;
  `};
`;

export default withTranslation()(HashtagCategoryItem);
